function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M128 256c0 35-29 64-64 64S0 291 0 256s29-64 64-64 64 29 64 64zm192 0c0 35-29 64-64 64s-64-29-64-64 29-64 64-64 64 29 64 64zm192 0c0 35-29 64-64 64s-64-29-64-64 29-64 64-64 64 29 64 64z"
}));